import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";
// import "../../components/toast.css";




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const HrExchangeShift = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        department:"",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.from_emp.toLowerCase()}${item.to_emp.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
		
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	





      const handleDepartment = async () => {
	  
        axios.get(API_BASE_URL +'/showdepartment/', { headers : {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem("authToken")}`
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);







const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);
	// alert(user.department);
    try {
      const response = await axios.post(API_BASE_URL +'/exchange_approval_list',
		{ exchange_date: user.start_date, dept_id: user.department }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
console.log(response.data.exchangeshift);
      setRecords(response.data.exchangeshift); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/exchange_approval_list',{exchange_date:''}, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response =>console.log(response.data.shiftattendance))
	 .then(response => setRecords(response.data.exchangeshift))
	.catch(err => console.log(err));
},[])




	


			


	const emptyUser={
	shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
	}



const [modalData, setModalData] = useState({
    shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
});

const handelModalInput = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
};

	const handleUpdate = async (user_id,attn_date) => {

		// console.log(user_id);
		// console.log(attn_date);

		axios.get(API_BASE_URL + '/read_shift_data/' + user_id +'/'+attn_date, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			
			.then(res1 => setModalData(res1.data.readshift))
			.then(res2=>setattnlist(res2.data.readshift.attn_list))
			.catch(err => console.log(err))
	};

	const handleDecision = async (action, exchange_id) => {

		
	const confirmMessage =
		action === "approve"
			? "Are you sure you want to approve this shift exchange?"
			: "Are you sure you want to reject this shift exchange?";

	if (!window.confirm(confirmMessage)) return;

	const endpoint =
		action === "approve" ? "/approveShiftExchange" : "/rejectShiftExchange";

	try {
		const response = await axios.get(API_BASE_URL + endpoint+'/'+exchange_id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});

		if (response.data.status === "success") {
			
			toast.success(response.data.message, {
						 position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
						style: {
							backgroundColor: "#28a745", // ✅ Bootstrap Success Green
							color: "#fff",              // White text
							fontWeight: "500"
						},
						});
			setTimeout(() => {
      window.location.href = "/shift-exchanges";
    }, 1500);
		} else {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				theme: "colored",
			});
			setTimeout(() => {
      window.location.href = "/shift-exchanges";
    }, 1500);
		}
	} catch (error) {
		toast.error(error.response?.data?.message || "An error occurred", {
			position: "bottom-right",
			autoClose: 5000,
			theme: "colored",
		});
	}
};



	const handleEditSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/update_shift_and_attendance', {shift_date : modalData.attendance_date, shift_code: modalData.shift_code, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.result, {
				position: "bottom-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				style: {
					backgroundColor: "#4CAF50 !important;", // ✅ success green
					color: "#fff",
					fontWeight: "bold",
					borderRadius: "8px",
					boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
				},
			});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};




	const columns = [
  { label: "Incharage", key: "incharge_info", sortable: true },
  { label: "From Employee", key: "from_emp", sortable: true },
  { label: "To Employee", key: "to_emp", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "From - To", key: "shift_exchange", sortable: true },
  { label: "Hr Approval", key: "puncapproval_statush_out", sortable: true }
];



	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									{/* <div className="card-header">
										<h3 className="card-title">My Shift</h3>
									</div> */}
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row">

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												<input type="date" className="form-control" name="start_date" value={user.start_date}
								onChange={handelInput} placeholder="Start Date" />
											
												</div>
											</div>

										

                                

                                    <div className="col-md-2 col-sm-6">
									<select className="form-control show-tick" name="department"  isSearchable={true} onChange={handelInput} // Enable search
														 value={user.department}>
										<option value="">All Department</option>
										{dataval.map(option => (
										<option key={option.department_id} value={option.department_id}>
										{option.department_name}
										</option>
										))}
									</select>
                                    </div>
                                    
							

								
								


                                <div className="col-md-4 col-sm-6">
									<div className="form-group">

                                <button type="submit" className="btn btn-primary">
								GET
							</button>

							

							
                            </div>
                            </div>



                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>








					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827'}}>Exchange Shift List</h3>
											<div className="card-options">
												<form>
													<div className="input-group">
													<EntriesSelector style={{
																			padding: '1px',
																			marginRight: '20px',
																			borderRadius: '4px',
																			border: '1px solid #ccc',
																			backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
																		}}
																		setEntriesPerPage={setEntriesPerPage}
																		setCurrentPage={setCurrentPage}
																		/> 
													
														 <input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
														/>
													</div>
												</form>
											</div>
										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive">
		

    
      
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
                                                           {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default" }}
      >
        {col.label}
       {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
		  </th>
    ))}
															
															
														</tr>
													</thead>
													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

                                                                let status;

                                                                if(record.approval_status==0)
                                                                {
                                                                    	status = (
                                                                            <>
                                                                                    <button
                                                                                        className="btn btn-primary"
                                                                                         onClick={() => handleDecision("approve", record.exchange_id)}
                                                                                    >
                                                                                        Approve
                                                                                    </button>

                                                                                    <button
                                                                                        className="btn btn-primary"
                                                                                         onClick={() => handleDecision("reject", record.exchange_id)}
                                                                                    >
                                                                                        Reject
                                                                                    </button>

                                                                                   </> 
                                                                                    );
                                                                }
                                                                else if(record.approval_status==1)
                                                                {
                                                                    status=record.hr_status;
                                                                }

															

															return(
															<tr key={record.incharge_info}>
																
																<td>{record.incharge_info}</td>
																<td>{record.from_emp}</td>
																<td>{record.to_emp}</td>
																<td>{record.shift_date}</td>
                                                                <td>{record.shift_exchange}</td>
                                                                <td>{record.approval_status}</td>
																<td>{status}</td>
																

															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="6" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HrExchangeShift);